import { ContentType, ErrorModelDto, HttpResponse } from "../http-client";
import { Api } from "./Api";
import type { LoginUserDto, UserDto } from "./Api";
import { ResponseCodes } from "./codes";

type GenericErrorModel = HttpResponse<unknown, ErrorModelDto>;

export const cdnUrl = process.env.REACT_APP_CDN_URL as string;
export const ruCdnUrl = (process.env.REACT_APP_CDN_URL_RU as string) || cdnUrl;

export const baseUrl = process.env.REACT_APP_SIRCAP_API as string;
export const ruBaseUrl = (process.env.REACT_APP_SIRCAP_API_RU as string) || baseUrl;

export const rtBaseUrl = process.env.REACT_APP_RT_SOCKET as string;
export const ruRtBaseUrl = (process.env.REACT_APP_RT_SOCKET_RU as string) || rtBaseUrl;

const sircapApi = new Api<string>({
  baseUrl: baseUrl,
  rtBaseUrl: rtBaseUrl,
  cdnUrl: cdnUrl,
  baseApiParams: {
    headers: {
      "Content-Type": ContentType.Json,
    },
    format: "json",
    secure: true,
  },
  securityWorker: (token) =>
    token ? { headers: { Authorization: `Bearer ${token}` } } : {},
});

export { sircapApi, ResponseCodes };
export type {
  LoginUserDto,
  UserDto,
  ErrorModelDto,
  HttpResponse,
  GenericErrorModel,
};
